package fr.frux.navigation

import fr.frux.shared.domain.session.SessionState

/**
 * Decide which screen the app starts on, from the restored session, the
 * persisted onboarding state and the deep link the app was opened with.
 *
 * Returns null while the session is [SessionState.Unknown]: the caller
 * must keep showing the splash, never a real screen.
 *
 * Sans session, un lien profond vers un écran public (fiche partagée, #385) démarre sur la
 * carte, pas sur l'écran de connexion. Un anonyme qui a fini l'accueil redémarre aussi sur la
 * carte (spec onboarding de contribution §1) : la connexion ne s'invite qu'au premier geste
 * réservé, comme le veut #264, et un lien muré empile le mur par-dessus la carte. Une session
 * expirée garde l'écran de connexion en base : la personne avait un compte.
 */
fun resolveStartRoute(
    session: SessionState,
    onboardingCompleted: Boolean,
    deepLink: Route? = null,
): Route? {
    val publicDeepLink = deepLink != null && !deepLink.requiresAuth
    return when (session) {
        SessionState.Unknown -> null
        is SessionState.Authenticated -> Route.Map
        SessionState.Expired -> if (publicDeepLink) Route.Map else Route.Auth
        SessionState.Anonymous -> if (publicDeepLink || onboardingCompleted) Route.Map else Route.Welcome
    }
}
